// extracted by mini-css-extract-plugin
export var compactFilters = "_e0-4";
export var detailImage = "_e0-1";
export var dropdownContainer = "_e0-2";
export var imageContainer = "_e0-0";
export var selectedCard = "_e0-3";